module.exports = __webpack_public_path__ + "img/proj1.eed91d84.png";